module.exports = __webpack_public_path__ + "img/clint-mckoy_old.440ba90f.jpg";